var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-ticket',{staticClass:"redpack",attrs:{"item":_vm.item,"typeName":'平台红包'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }